module.exports = __webpack_public_path__ + "static/media/Mint_POAP.5e1fba0a.svg";